'use strict';

var React = require('react');
var useMatchDevice = require('../../hooks/useMatchDevice.js');
require('imask');
require('resize-observer-polyfill');
var component = require('../Button/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const ModalFooterButton = React.forwardRef(({ hiddenInMobile, ...buttonProps }, ref) => {
    const isMobile = useMatchDevice.useMatchDevice('mobile');
    return hiddenInMobile && isMobile ? null : React__default.default.createElement(component.Button, { ...buttonProps, ref: ref, fullWidth: isMobile });
});
ModalFooterButton.displayName = 'Modal.FooterButton';

exports.ModalFooterButton = ModalFooterButton;
//# sourceMappingURL=FooterButton.js.map
